import { MultiInputStreamBasePlainObject } from './multiInputStreamBase.plainObject';

export class ExistsPlainObject extends MultiInputStreamBasePlainObject {
    public customExpression: string;
}
